import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import {
  saveBalance,
  saveBalanceFailure,
  startUpload,
  stopUpload,
  clearAjaxCall
} from '../../actions/Balance'

import Modal from '../Modal'

import { paymentTypes, directionTypes } from '../../options.json'

class EditReceipt extends Component {
  constructor() {
    super()
    this._handleImageChange = this._handleImageChange.bind(this)
  }
  saveBalance() {
    const b = this.state
    if (b.amount === '') {
      this.props.saveBalanceFailure('Verificare i dati immessi')
      setTimeout(() => {
        this.props.clearAjaxCall('')
      }, 3000)
    } else {
      this.props.saveBalance({
        id: b.id,
        number: b.number,
        direction: b.direction,
        emitter: b.emitter,
        amount: b.amount,
        causal: b.causal,
        emission_date:
          b.emission_date !== ''
            ? moment.utc(b.emission_date).startOf('day').unix()
            : '',
        payment_mode:
          b.payment_mode !== '' ? b.payment_mode : paymentTypes[0].value,
        course_id: b.course_id,
        doc: b.doc,
        doc_name: b.doc_name,
        doc_delete: b.doc_delete,
        notes: b.notes
      })
    }
  }
  _handleImageChange(e) {
    e.preventDefault()
    let reader = new window.FileReader()
    if (e.target.files.length > 0) {
      let file = e.target.files[0]
      this.props.startUpload()
      reader.onloadend = () => {
        this.setState({
          doc: reader.result,
          doc_name: file.name,
          doc_delete: true,
          doc_delete_lock: true
        })
        this.props.stopUpload()
      }
      reader.readAsDataURL(file)
    } else {
      this.setState({
        doc: '',
        doc_name: '',
        doc_delete: false,
        doc_delete_lock: false
      })
    }
  }
  componentWillMount() {
    const b = this.props.b
    this.setState({
      id: b.id,
      number: b.number,
      direction: b.direction,
      amount: b.amount,
      causal: b.causal,
      emitter: b.emitter,
      emission_date:
        b.emission_date !== ''
          ? moment.unix(b.emission_date).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD'),
      payment_mode: b.payment_mode,
      course_id: b.course_id,
      doc: '',
      doc_name: '',
      doc_delete: false,
      doc_delete_lock: false,
      checksum: b.checksum,
      notes: b.notes
    })
  }
  render() {
    const { ajaxStatus } = this.props.balance
    const { list } = this.props.courses
    const b = this.state
    return (
      <Modal>
        <h3>{b.id !== null ? 'Modifica' : 'Nuovo'} Movimento</h3>
        <button
          className='lnk-close-modal'
          onClick={() => this.props.hideModal()}
          aria-label='Chiudi'
        >
          <i className='fa fa-times' aria-hidden='true'></i>
        </button>
        <label>
          Direzione
          <select
            onChange={(event) =>
              this.setState({ direction: event.target.value })
            }
            value={b.direction}
          >
            {directionTypes.map((i, index) => {
              return (
                <option key={index} value={i.value}>
                  {i.label}
                </option>
              )
            })}
          </select>
        </label>
        <label>
          Numero fattura &nbsp;
          <input
            type='text'
            onChange={(event) => this.setState({ number: event.target.value })}
            value={b.number}
          />
        </label>
        <label>
          Emessa da &nbsp;
          <input
            type='text'
            onChange={(event) => this.setState({ emitter: event.target.value })}
            value={b.emitter}
          />
        </label>
        <label>
          Importo
          <input
            type='number'
            placeholder='Importo'
            onChange={(event) => this.setState({ amount: event.target.value })}
            value={b.amount}
          />
        </label>
        <label>
          Corso
          <select
            onChange={(event) =>
              this.setState({ course_id: event.target.value })
            }
            value={b.course_id}
          >
            <option value=''></option>
            {list !== null &&
              list.map((m, index) => {
                return (
                  <option key={index} value={m.id}>
                    {m.name}
                  </option>
                )
              })}
          </select>
        </label>
        <label>
          Causale
          <input
            type='text'
            placeholder='Causale'
            onChange={(event) => this.setState({ causal: event.target.value })}
            value={b.causal}
          />
        </label>
        <label>
          Data emissione
          <input
            type='date'
            placeholder='Data emissione'
            // disabled={b.id !== null}
            onChange={(event) =>
              this.setState({ emission_date: event.target.value })
            }
            value={b.emission_date}
          />
        </label>
        <label>
          Modalità pagamento
          <select
            onChange={(event) =>
              this.setState({ payment_mode: event.target.value })
            }
            value={b.payment_mode}
          >
            {paymentTypes.map((i, index) => {
              return (
                <option key={index} value={i.value}>
                  {i.label}
                </option>
              )
            })}
          </select>
        </label>
        <label>
          Allega documento
          <input
            type='file'
            ref={(ref) => (this.upload = ref)}
            onChange={this._handleImageChange}
          />
        </label>
        {b.checksum !== '' && (
          <label className='check-container'>
            Elimina documento allegato precedentemente
            <input
              type='checkbox'
              disabled={b.doc_delete_lock ? 'disabled' : ''}
              onChange={(event) =>
                this.setState({ doc_delete: event.target.checked })
              }
              value={b.doc_delete}
              checked={b.doc_delete}
            />
            <span className='checkmark'></span>
          </label>
        )}
        <label>
          Note
          <textarea
            placeholder='Note'
            onChange={(event) => this.setState({ notes: event.target.value })}
            value={b.notes}
          ></textarea>
        </label>
        <ul className='submit-btn'>
          <li>
            <span className='ajax-error'>{ajaxStatus}</span>
          </li>
          <li>
            <button
              className='lnk-submit'
              onClick={() => this.props.hideModal()}
            >
              annulla
            </button>
          </li>
          <li>
            <button className='lnk-submit' onClick={() => this.saveBalance()}>
              salva
            </button>
          </li>
        </ul>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  saveBalance,
  saveBalanceFailure,
  startUpload,
  stopUpload,
  clearAjaxCall
})(EditReceipt)



// WEBPACK FOOTER //
// ./src/components/Balance/EditBalance.js